import React, { useState, useEffect } from 'react';
import NextNavLink from '../../components/util/NextNavLink';
import { useWindowDimensions } from '../../util/hooks';
import { Transition } from '@headlessui/react';

let loadCount = 1;

const Posts = ({
    events,
    filterCategories,
    searchQuery,
    setSearchQuery,
    acf_post_event
}) => {
    const [showSearch, setShowSearch] = useState(
        useWindowDimensions().width < 1024 ? false : true
    );

    useEffect(() => {
        let w = useWindowDimensions().width;
        if (w < 1024 && !showSearch) {
            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        } else if (w >= 1024) {
            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }
    }, [showSearch]);

    function handleResize() {
        setShowSearch(useWindowDimensions().width < 1024 ? false : true);
    }

    /*
     * Every render, retrieve a filtered copy of the insights.
     */
    let eventPosts = events.filter((item) => {
        /*
         * If there is a search query, skip this insight if neither its
         * title nor excerpt contain the search query.
         */
        if (
            !item.title?.toLowerCase().includes(searchQuery.toLowerCase()) &&
            !item?.content?.toLowerCase().includes(searchQuery.toLowerCase())
        ) {
            return false;
        }

        /* If there are no filter categories set, assume we want all. */
        if (!filterCategories.length) {
            return true;
        }

        /* Does this insight have any of the categories selected in our filter? */
        for (let i = 0; i < item?.eventTypes?.nodes?.length; i++) {
            let node = item?.eventTypes?.nodes[i];
            if (filterCategories.includes(node.slug)) {
                return true;
            }
        }

        for (let i = 0; i < item?.eventRegions?.nodes?.length; i++) {
            let node = item?.eventRegions?.nodes[i];

            if (filterCategories.includes(node.slug)) {
                return true;
            }
        }
        for (let i = 0; i < item?.eventMonths?.nodes?.length; i++) {
            let node = item?.eventMonths?.nodes[i];

            if (filterCategories.includes(node.slug)) {
                return true;
            }
        }
        for (let i = 0; i < item?.eventTopics?.nodes?.length; i++) {
            let node = item?.eventTopics?.nodes[i];

            if (filterCategories.includes(node.slug)) {
                return true;
            }
        }

        for (let i = 0; i < item?.eventSegments?.nodes?.length; i++) {
            let node = item?.eventSegments?.nodes[i];

            if (filterCategories.includes(node.slug)) {
                return true;
            }
        }

        /* No match. */
        return false;
    });

    //Count max post load
    let maxLoad = Math.ceil(eventPosts.length / 21);

    // set init posts
    const [posts, setPosts] = useState(eventPosts.slice(0, 21));

    /*
     * When the filter criteria change, reset state to the
     * first ten filtered insights.
     */
    useEffect(() => {
        setPosts(eventPosts.slice(0, 21));
    }, [filterCategories, searchQuery]);

    //load more function
    function loadmore(e) {
        e.preventDefault();
        loadCount++;
        setPosts(eventPosts.slice(0, 21 * loadCount));
        // hide button on max Post limit
        if (loadCount === maxLoad || loadCount >= maxLoad) {
            e.target.classList.add('hidden');
        }
    }

    return (
        <>
            <div
                className="absolute right-0 font-medium top-4 lead lg:hidden"
                onClick={() => setShowSearch(!showSearch)}
            >
                <div className="inline-flex items-center lead">
                    Search <i className="ml-2 en-search"></i>
                </div>
            </div>
            <Transition
                show={showSearch}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                className="lg:block flex flex-col fixed lg:relative top-0  left-0 lg:z-0 z-[101] w-full h-screen lg:h-auto p-6 lg:p-0 lg:overflow-hidden overflow-auto bg-white"
            >
                <div className="flex items-center justify-between mb-12 lg:hidden">
                    <h5 className="mb-0 lg:pb-6 lg:mb-16 lg:border-b border-purple-midnight border-opacity-20">
                        Search
                    </h5>
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            setShowSearch(false);
                        }}
                        className="flex items-center font-medium lead opacity-80 hover:opacity-100 text-purple-midnight lg:hidden"
                    >
                        <span className="min-w-[42px]">Close</span>
                        <span
                            className={`icon-expaded relative h-6 w-6 flex-col justify-between items-center flex ml-3`}
                        >
                            <span
                                className={`absolute inline-block w-1 h-1 rounded-10 bg-purple-midnight`}
                            ></span>
                            <span
                                className={`relative top-0 inline-block w-1 h-1 rounded-10 bg-purple-midnight`}
                            ></span>
                            <span
                                className={`inline-block w-1 h-1 rounded-10 bg-purple-midnight`}
                            ></span>
                            <span
                                className={`relative bottom-0 inline-block w-1 h-1 rounded-10 bg-purple-midnight`}
                            ></span>
                            <span
                                className={`absolute bottom-0 inline-block w-1 h-1 rounded-10 bg-purple-midnight`}
                            ></span>
                        </span>
                    </a>
                </div>
                <div className="flex items-center flex-1">
                    <div className="relative w-full mb-16">
                        <input
                            className="w-full px-0 py-3 pt-4 pb-4 border-0 border-b lg:pb-6 lg:pt-0 border-opacity-20 border-purple-midnight focus:border-opacity-20 focus:border-purple-midnight h5 focus:outline-none search-filter placeholder-purple-midnight"
                            type="text"
                            placeholder="Search"
                            value={searchQuery}
                            onInput={(ev) => setSearchQuery(ev.target.value)}
                        />
                        <a
                            href=""
                            onClick={(e) => {
                                setShowSearch(
                                    useWindowDimensions().width < 1024
                                        ? false
                                        : true
                                );
                                e.preventDefault();
                            }}
                            className="absolute right-0 inline-flex items-center justify-center w-12 h-12 text-white lg:top-0 top-2 rounded-30 bg-purple-midnight"
                        >
                            <i className="en-search"></i>
                        </a>
                    </div>
                </div>
            </Transition>
            <ul className="grid gap-8 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 ">
                {posts.map(
                    (
                        {
                            slug,
                            title,
                            featuredImage,
                            date,
                            eventsId,
                            eventTypes,
                            acfAwardsLink,
                            acf_post_event
                        },
                        index
                    ) =>
                        index === 0 ? (
                            <li
                                key={eventsId}
                                className="col-span-1 lg:col-span-3 sm:col-span-2 wow fadeInUp"
                            >
                                <article
                                    className="grid gap-4 pb-16 mb-8 border-b md:gap-16 md:grid-cols-2 border-purple-midnight border-opacity-20"
                                    id={`post-${eventsId}`}
                                >
                                    <div className="flex flex-1">
                                        <div
                                            className={` bg-cover bg-center aspect-w-1 aspect-h-1 w-full  ${
                                                !featuredImage?.node
                                                    ?.mediaItemUrl
                                                    ? `bg-gradient-${Math.floor(
                                                          Math.random() *
                                                              (12 - 7) +
                                                              7
                                                      )}`
                                                    : ''
                                            }`}
                                            style={
                                                featuredImage?.node
                                                    ?.mediaItemUrl
                                                    ? {
                                                          backgroundImage: `url(${featuredImage?.node?.mediaItemUrl})`
                                                      }
                                                    : {}
                                            }
                                        ></div>
                                    </div>
                                    <div className="flex items-center flex-1">
                                        <div>
                                            <p className="mb-1 font-medium label label--small">
                                                {eventTypes?.nodes[0]
                                                    ? eventTypes?.nodes[0]?.name
                                                    : 'Event'}
                                            </p>
                                            {/* {getDate(date)} */}
                                            {acf_post_event?.eventDate && (
                                                <div
                                                    className="mb-4 font-medium opacity-50 label label--small"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            acf_post_event?.eventDate
                                                    }}
                                                />
                                            )}
                                            <h5
                                                className=""
                                                dangerouslySetInnerHTML={{
                                                    __html: title
                                                }}
                                            />
                                            <NextNavLink
                                                href={`${
                                                    acfAwardsLink?.link
                                                        ? acfAwardsLink?.link
                                                        : `/events/${slug}`
                                                }`}
                                                target={`${
                                                    acfAwardsLink?.link
                                                        ? '_blank'
                                                        : '_self'
                                                }`}
                                            >
                                                <a className="inline-flex items-center mt-4 font-medium text-purple hover:text-purple-midnight lead icon-circle">
                                                    Read More
                                                    <i className="inline-block en-long-arrow text-32 leading-18 relative z-[1] ml-4"></i>
                                                </a>
                                            </NextNavLink>
                                        </div>
                                    </div>
                                </article>
                            </li>
                        ) : (
                            <li key={eventsId}>
                                <article
                                    className="mb-8 wow fadeInUp"
                                    id={`post-${eventsId}`}
                                >
                                    <div
                                        className={`aspect-w-1 aspect-h-1 mb-4 bg-cover bg-center ${
                                            !featuredImage?.node?.mediaItemUrl
                                                ? `bg-gradient-${Math.floor(
                                                      Math.random() * (12 - 7) +
                                                          7
                                                  )}`
                                                : ''
                                        }`}
                                        style={
                                            featuredImage?.node?.mediaItemUrl
                                                ? {
                                                      backgroundImage: `url(${featuredImage?.node?.mediaItemUrl})`
                                                  }
                                                : {}
                                        }
                                    ></div>
                                    <p className="mb-1 font-medium label label--small">
                                        {eventTypes?.nodes[0]
                                            ? eventTypes?.nodes[0]?.name
                                            : 'Event'}
                                    </p>
                                    {acf_post_event?.eventDate && (
                                        <div
                                            className="mb-4 font-medium opacity-50 label label--small"
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    acf_post_event?.eventDate
                                            }}
                                        />
                                    )}
                                    <div
                                        className="lead lead--large"
                                        dangerouslySetInnerHTML={{
                                            __html: title
                                        }}
                                    />
                                    <NextNavLink
                                        href={`${
                                            acfAwardsLink?.link
                                                ? acfAwardsLink?.link
                                                : `/events/${slug}`
                                        }`}
                                        target={`${
                                            acfAwardsLink?.link
                                                ? '_blank'
                                                : '_self'
                                        }`}
                                    >
                                        <a className="inline-flex items-center mt-4 font-medium text-purple hover:text-purple-midnight lead icon-circle">
                                            Read More
                                            <i className="inline-block en-long-arrow text-32 leading-18 relative z-[1] ml-4"></i>
                                        </a>
                                    </NextNavLink>
                                </article>
                            </li>
                        )
                )}
            </ul>

            {posts.length > 21 ? (
                <div className="text-center">
                    <a
                        href=""
                        onClick={loadmore}
                        className="text-center btn btn--light btn--lg my-28"
                    >
                        Load More
                    </a>
                </div>
            ) : (
                ''
            )}
            {posts.length === 0 ? <h3>No post found</h3> : ''}
        </>
    );
};

function getDate(date) {
    let d = new Date(date);
    var month = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    let getYear = d.getFullYear();
    let getMonth = d.getMonth();
    getMonth = month[getMonth];
    let getDay = d.getDate();
    return (
        <p className="mb-4 font-medium opacity-50 label label--small">
            {getMonth}.{getDay}.{getYear}
        </p>
    );
}
export default Posts;
